import React, { useState } from "react";
import { Tooltip, message } from "antd";
import axios from "axios";
import { useSelector } from "react-redux";
import { EyeOutlined, FileTextOutlined, FilePdfOutlined, FileSearchOutlined } from "@ant-design/icons";
import ButtonItem from "./ButtonItem";
import ModalPolizasDocumento from "./ModalPolizasDocumento";

const estiloTooltip = { fontSize: "10px", padding: "1px 5px", minHeight: "auto" };

// Las tres pantallas de factura de proveedor cargan con facturas/datosFactura
const rutaFactura = (factura) => {
  if (factura.ordenDeCompraId || factura.ordenesDeCompraIds?.length) return "/panel/verFacturaOrdenDeCompra";
  if (factura.cajaId) return "/panel/verFacturaCajaChica";
  return "/panel/verFacturaSinOrdenDeCompra";
};

const BotonesOrigenCargoAbono = ({ ventaId, polizaId, facturaId, history, onVerPoliza }) => {
  const [modalPolizasFactura, setModalPolizasFactura] = useState(false);
  const [modalPolizasVenta, setModalPolizasVenta] = useState(false);
  const [abriendoFactura, setAbriendoFactura] = useState(false);
  const empresaId = useSelector((state) => state.empresa.id);
  const headersToken = useSelector((state) => state.user.headersToken);

  const verFactura = () => {
    setAbriendoFactura(true);
    axios
      .post("facturas/datosFactura", { empresaId, facturaId }, { headers: headersToken })
      .then((res) => {
        setAbriendoFactura(false);
        if (res.data.success === 2 && res.data.factura) {
          history.push(rutaFactura(res.data.factura), { id: facturaId });
        } else {
          message.error("No se encontró la factura de este movimiento");
        }
      })
      .catch(() => {
        setAbriendoFactura(false);
        message.error("Hubo un error y no se pudo abrir la factura");
      });
  };

  return (
    <div className="acciones-container">
      {ventaId && (
        <>
          <Tooltip title="Ver venta" placement="top" overlayInnerStyle={estiloTooltip}>
            <ButtonItem
              type="default"
              size="small"
              azul
              icon={<EyeOutlined />}
              onClick={() => history.push("/panel/verVenta", { id: ventaId })}
            />
          </Tooltip>
          <Tooltip title="Ver pólizas de esta venta" placement="top" overlayInnerStyle={estiloTooltip}>
            <ButtonItem
              type="default"
              size="small"
              morado
              icon={<FilePdfOutlined />}
              onClick={() => setModalPolizasVenta(true)}
            />
          </Tooltip>
          <ModalPolizasDocumento
            visible={modalPolizasVenta}
            tipo="venta"
            documentoId={ventaId}
            titulo="Pólizas de la Venta"
            onCancel={() => setModalPolizasVenta(false)}
          />
        </>
      )}
      {facturaId && (
        <>
          <Tooltip title="Ver factura" placement="top" overlayInnerStyle={estiloTooltip}>
            <ButtonItem
              type="default"
              size="small"
              naranja2
              loading={abriendoFactura}
              icon={<FileSearchOutlined />}
              onClick={verFactura}
            />
          </Tooltip>
          <Tooltip title="Ver pólizas de esta factura" placement="top" overlayInnerStyle={estiloTooltip}>
            <ButtonItem
              type="default"
              size="small"
              morado
              icon={<FilePdfOutlined />}
              onClick={() => setModalPolizasFactura(true)}
            />
          </Tooltip>
          <ModalPolizasDocumento
            visible={modalPolizasFactura}
            tipo="factura"
            documentoId={facturaId}
            titulo="Pólizas de la Factura"
            onCancel={() => setModalPolizasFactura(false)}
          />
        </>
      )}
      {polizaId && (
        <Tooltip title="Ver póliza" placement="top" overlayInnerStyle={estiloTooltip}>
          <ButtonItem
            type="default"
            size="small"
            cyan
            icon={<FileTextOutlined />}
            onClick={() => onVerPoliza(polizaId)}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default React.memo(BotonesOrigenCargoAbono);
